import { Injectable } from '@angular/core';

import { ApiService }           from '../api/api.service';
import { InvoiceModel }         from '../invoices/models/invoice';
import { TableQueryParameters } from '../table/types/table-query-parameters';

@Injectable({
  providedIn: 'root'
})
export class QuotesService {
  constructor (
    private apiService : ApiService
  ) {}

  getAcceptedQuotes ( params : TableQueryParameters = {} ) : Promise<Array<InvoiceModel>> {
    return this.apiService.get('/dashboard/accepted_quotes_list', [
        params.pageSize || 5,
        params.offset   || 0
      ]);
  }

  getAcceptedQuotesCount () : Promise<number> {


    return this.apiService.get('/dashboard/accepted_quotes_count')
      .then(( result ) => result.count);


  }
}
